$(document).ready(function(){
    var minus = $('#minus-arrow');
    var plus = $('#plus-arrow');
    var qty = $('.product-form__input--quantity');

    minus.on('click', function(){
        var val = qty.val();
        if(val > 1){
            val--;
            qty.val(val);
        }
    })

    plus.on('click', function(){
        var val = qty.val();
            val++;
            qty.val(val);
    })
})
